export default __webpack_public_path__ + "static/media/upload.affd37f9.svg";